/* Monster Card Corner: tiny consent-gated event tracker for the 404 page and empty basket.
   Same rules as the homepage hero: Shopify customer events always, GA4 only after analytics consent. */
(function () {
  if (window.mccTrack) return;
  var consentLoad = null;
  function api() {
    var sh = window.Shopify;
    return sh && sh.customerPrivacy && typeof sh.customerPrivacy.analyticsProcessingAllowed === 'function' ? sh.customerPrivacy : null;
  }
  function allowed() {
    if (!consentLoad) {
      consentLoad = api() ? Promise.resolve(true) : new Promise(function (resolve) {
        try {
          var sh = window.Shopify;
          if (!sh || typeof sh.loadFeatures !== 'function') { resolve(false); return; }
          sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { resolve(!err && !!api()); });
          setTimeout(function () { resolve(!!api()); }, 5000);
        } catch (e) { resolve(false); }
      });
    }
    return consentLoad.then(function (ok) { try { return ok && !!api().analyticsProcessingAllowed(); } catch (e) { return false; } });
  }
  function clean(p) {
    var out = {};
    Object.keys(p || {}).slice(0, 24).forEach(function (k) {
      var v = p[k];
      if (v === undefined || v === null || v === '') return;
      out[String(k).slice(0, 40)] = typeof v === 'string' ? v.slice(0, 100) : v;
    });
    return out;
  }
  function layout() { return matchMedia('(max-width: 749px)').matches ? 'mobile' : matchMedia('(max-width: 989px)').matches ? 'tablet' : 'desktop'; }
  window.mccTrack = function (name, params) {
    try {
      var p = clean(Object.assign({ layout: layout() }, params || {}));
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, p); } catch (e) {}
      if (typeof window.gtag !== 'function') return;
      allowed().then(function (ok) { if (ok) { try { window.gtag('event', name, p); } catch (e) {} } });
    } catch (e) { /* tracking must never break the page */ }
  };
  var pathOf = function (a) { try { return new URL(a.getAttribute('href'), location.href).pathname; } catch (e) { return ''; } };
  // the drawer's mascot waits until the drawer is actually on screen (it is pre-rendered, hidden, on every page)
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
  }) : null;
  function show(img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
  function wake() {
    document.querySelectorAll('img.mcc-empty-adv__mascot[data-src]').forEach(function (img) { io ? io.observe(img) : show(img); });
  }
  wake();
  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) new MutationObserver(wake).observe(drawer, { childList: true, subtree: true });
  // empty basket portals (cart page + drawer; the drawer re-renders, so listen on the document)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.mcc-empty-adv a[href]');
    if (!a) return;
    window.mccTrack('mcc_empty_cart_click', { label: a.textContent.trim(), link_path: pathOf(a), surface: a.closest('cart-drawer') ? 'drawer' : 'cart_page', page_type: 'cart' });
  });
  // 404 "undiscovered world"
  var lost = document.querySelector('[data-mcc404]');
  if (lost) {
    var ref = ''; try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    window.mccTrack('mcc_404_view', { page_type: '404', missing_path: location.pathname, referrer_host: ref || 'direct' });
    lost.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (a) window.mccTrack('mcc_404_click', { page_type: '404', target: a.closest('.mcc404__portals') ? 'portal' : 'home', label: a.textContent.trim(), link_path: pathOf(a) });
    });
    var f = lost.querySelector('form');
    if (f) f.addEventListener('submit', function () {
      var q = (f.querySelector('input[name="q"]') || {}).value || '';
      window.mccTrack('mcc_404_click', { page_type: '404', target: 'search', query_length: q.trim().length });   // never the query text
    });
  }
})();
